import { render, staticRenderFns } from "./TemplateSelect.vue?vue&type=template&id=3c4180ce&"
import script from "./TemplateSelect.vue?vue&type=script&lang=js&"
export * from "./TemplateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports